const additionalPadding = ref(0);

export const useSnackbarPadding = () => {
  return additionalPadding;
};

export const useSetSnackbarPadding = (p: number) => {
  console.log('useSetSnackbarPadding: , ', p);
  additionalPadding.value = p;
};
